<template>
	<div class="page">
		<!-- 页面路径 -->
		<div class="pageRouter f-bct">
			<div class="l f-ct">
				当前位置：
				<!-- <span>首页</span>
				<el-image :src="require('@/static/icon23.png')"></el-image>
				<span>协会动态</span>
				<el-image :src="require('@/static/icon23.png')"></el-image> -->
				<span class="blue">文章详情</span>
			</div>
			<div class="r f-ct" @click="back()">
				<span class="blue">返回上一页</span>
				<el-image :src="require('@/static/icon27.png')"></el-image>
			</div>
		</div>
		<div class="txtMsg animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="richBox">
				<div class="tit">{{pageMsg.title}}</div>
				<div class="time">发布日期：{{quSFM(pageMsg.createTime)}}&emsp;来源：{{pageMsg.source}}</div>
				<!-- <div class="time">发布日期：{{quSFM(pageMsg.createTime)}}</div> -->
				<div class="txt" v-html="pageMsg.content"></div>
			</div>
			<div class="change">
				<p @click="link('dynamicMsg',{id:pageMsg1.id})" v-if="pageMsg1">上一篇：{{pageMsg1.title}}</p>
				<p @click="link('dynamicMsg',{id:pageMsg2.id})" v-if="pageMsg2">下一篇：{{pageMsg2.title}}</p>
			</div>
		</div>
	</div>
</template>
<script>
import { articledetail } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			pageMsg:'',
			pageMsg1:'',
			pageMsg2:'',
		}
	},
	mounted() {
		// console.log(this.$route.query)
		this.articledetail()
	},
	watch:{
		'$route.query':function(){
			this.articledetail()
		},
	},
	methods:{
		// 文章详情
		async articledetail(){
			let res = await articledetail({id:this.$route.query.id});
			if(res.code==200){
				this.pageMsg = res.data
				if(res.data.prevArticle){
					this.articledetail1(res.data.prevArticle.id)
				}else{
					this.pageMsg1 = ''
				}
				if(res.data.nextArticle){
					this.articledetail2(res.data.nextArticle.id)
				}else{
					this.pageMsg2 = ''
				}
			}else{this.Tips(res.msg,'error')}
		},
		// 文章详情
		async articledetail1(id){
			let res = await articledetail({id});
			if(res.code==200){
				this.pageMsg1 = res.data
			}else{
				this.pageMsg2 = ''
			}
		},
		// 文章详情
		async articledetail2(id){
			let res = await articledetail({id});
			if(res.code==200){
				this.pageMsg2 = res.data
			}else{
				this.pageMsg2 = ''
			}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.page{
	width: 1200px;
	margin: auto;
	padding-bottom: 20px;
}
.pageRouter{
	padding: 24px 0;
	font-size: 16px;
	.l{
		span{
			color: #666666;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 3px;
		}
		.blue{
			color: #3B6492;
		}
	}
	.r{
		cursor: pointer;
		.blue{
			color: #3B6492;
		}
		.el-image{
			margin-left: 6px;
			width: 18px;
			height: 18px;
		}
	}
}
.txtMsg{
	background: #fff;
	padding-left: 31px;
	padding-right: 17px;
	padding: 0 31px;
	.richBox{
		.tit{
			font-size: 24px;
			padding-top: 36px;
			padding-bottom: 17px;
			text-align: center;
		}
		.time{
			text-align: center;
			font-size: 16px;
			color: #999999;
			padding-bottom: 32px;
			border-bottom: 1px solid #EEEEEE;
		}
		.txt{
			padding: 32px 25px;
			border-bottom: 1px solid #EEEEEE;
			color: #545964;
			font-size: 16px;
			line-height: 35px;
			overflow: hidden;
			::v-deep img{
				width: 100%!important;
			}
		}
	}
	.change{
		padding: 12px 25px;
		padding-left: 25px;
		p{
			padding: 12px 0;
			color: #545964;
			font-size: 16px;
			cursor: pointer;
			&:hover{
				color: #3B6492;
			}
		}
	}
}
</style>